import {cx} from "@emotion/css";
import {ReactComponent as SvgEyeOff} from "assets/svg/eye-off.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmEyeOffIcon: React.FC<IIconBase> = ({id, size = "md", color = designColors.black, className}) => {
  return <SvgEyeOff id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
